import { blockRows, blockSeverity } from "../utils/parsers";

export default function ProcessedTab({
  blocks,
  status,
  error,
  selectedDate,
  onDateChange,
}) {
  return (
    <div className="blocks-wrapper">
      <div className="dashboard-panel">
        <div className="date-picker">
          <label htmlFor="history-date">Select Date</label>
          <input
            id="history-date"
            type="date"
            value={selectedDate || ""}
            onChange={(e) => onDateChange(e.target.value || null)}
          />
        </div>

        {status === "loading" && (
          <p className="status-text">Loading processed videos...</p>
        )}
        {status === "error" && (
          <p className="status-text error">
            Could not load processed videos: {error}
          </p>
        )}
        {status === "ready" && blocks.length === 0 && (
          <p className="status-text">No processed videos for this selection.</p>
        )}

        <div className="blocks-column">
          {blocks.map((block, index) => (
            <div
              key={`${block.date}-${block.site_id ?? index}`}
              className={`white-block ${blockSeverity(block)}`}
            >
              <div className="block-title">{block.date}</div>
              {blockRows(block).map((row) => (
                <div className="block-row" key={row.label}>
                  <span>{row.label}</span>
                  <span>{row.value}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
